import { render, staticRenderFns } from "./contentElementRecipe.vue?vue&type=template&id=57cf805f&scoped=true"
import script from "./contentElementRecipe.vue?vue&type=script&lang=js"
export * from "./contentElementRecipe.vue?vue&type=script&lang=js"
import style0 from "./contentElementRecipe.vue?vue&type=style&index=0&id=57cf805f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cf805f",
  null
  
)

export default component.exports